import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import BracketMatchTeam from './bracket-match-team';

import styles from './bracket-match.module.css';

const BracketMatch = ({teams, className}) => {
  const isMatchFinished = teams?.some(team => team?.score);
  const isFirstTeamWinner = teams?.[0]?.score > teams?.[1]?.score;

  return (
    <div className={clsx(styles.matchWrapper, className)}>
      <div className={styles.teamWrapper}>
        <BracketMatchTeam
          team={teams?.[0]}
          winner={isMatchFinished && isFirstTeamWinner}
          loser={isMatchFinished && !isFirstTeamWinner}
        />
      </div>
      <div className={styles.teamWrapper}>
        <BracketMatchTeam
          team={teams?.[1]}
          winner={isMatchFinished && !isFirstTeamWinner}
          loser={isMatchFinished && isFirstTeamWinner}
        />
      </div>
    </div>
  );
};

BracketMatch.propTypes = {
  teams: PropTypes.arrayOf(BracketMatchTeam.propTypes.team),
  className: PropTypes.string
};

BracketMatch.defaultProps = {
  teams: [],
  className: ''
};

export default BracketMatch;
